import SeekForward from '../assets/images/seek-forward.svg';
import SeekBackward from '../assets/images/seek-back.svg';

import "./seek-button.css";

const MenuButtonComponent = videojs.getComponent('MenuButton');
let localize;

export class SeekButton extends MenuButtonComponent {
    constructor(player, options = {}) {
        localize = player.localize?.bind(player);

        const isForward = options.isForward;
        const name = isForward ? "SeekForwardButton" : "SeekBackButton";

        options.clickHandler = () => {
            player.currentTime(player.currentTime() + (options.seekDuration * ((isForward) ? 1 : -1)));
        }

        super(player, Object.assign({ name: name }, options));
        this.addClass('mediasite-player__seek-button');
        this.addClass('mediasite-player__custom-controlbar-button');

        this.el().style.setProperty('--custom-controlbar-icon', `url("${(isForward) ? SeekForward : SeekBackward}")`);

        if (isForward) {
            this.controlText(localize(`Seek forward ${options.seekDuration} seconds (→)`));
        } else {
            this.controlText(localize(`Seek back ${options.seekDuration} seconds (←)`));
        }
    }
}